"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNumberFieldParameters = void 0;
const common_1 = require("./common");
exports.defaultNumberFieldParameters = {
    ["allow_negative"]: false,
    ["allow_zero"]: true,
    ["separator"]: false,
    ["precision"]: 0,
    ["value_increment"]: 1,
    ["locale"]: { value: common_1.DefaultLocale.value },
    ["decimal_separator"]: null,
};
